import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import cn from 'classnames';
import { Badge, Card, Typography } from 'seagull';
import { YoutubePlayer } from '~/components/YoutubePlayer/YoutubePlayer';
import styles from './VideoCardItem.module.scss';
export const VideoCardItem = (param)=>{
    let { video, onSelect, isActive, variant } = param;
    const { id, title, watched, duration } = video;
    const isPortrait = variant === 'portrait';
    const isMobile = variant === 'mobile';
    const [videoWidth, videoHeight] = useMemo(()=>{
        switch(variant){
            case 'portrait':
                return [
                    '358px',
                    '224px'
                ];
            case 'desktop':
                return [
                    '179px',
                    '112px'
                ];
            case 'mobile':
                return [
                    '152px',
                    '96px'
                ];
        }
    }, [
        variant
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.VideoItemContainer,
        children: /*#__PURE__*/ _jsxs(Card, {
            bi: {
                name: 'tutorial_video_card',
                data: {
                    video_id: video.id
                }
            },
            autoHeight: isMobile,
            className: cn(styles.VideoItemCard, {
                [styles.played]: isActive,
                [styles.mobile]: isMobile
            }),
            testId: "tutorial-video-".concat(video.id),
            as: "button",
            highlightOnHover: true,
            onClick: ()=>onSelect(video),
            children: [
                /*#__PURE__*/ _jsx(YoutubePlayer, {
                    className: styles.thumbnail,
                    controls: false,
                    playIcon: /*#__PURE__*/ _jsx(_Fragment, {}),
                    width: videoWidth,
                    height: videoHeight,
                    light: true,
                    url: "https://youtu.be/".concat(id)
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: cn(styles.videoInfo, {
                        [styles.mobile]: isMobile
                    }),
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: isPortrait ? 'h3' : 'paragraph2',
                            weight: "bold",
                            className: styles.videoTitle,
                            testId: "tutorial-video-title",
                            children: title
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.durationRow,
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    className: styles.videoDuration,
                                    variant: isPortrait ? 'h4' : 'paragraph2',
                                    weight: "light",
                                    testId: "tutorial-video-duration",
                                    children: "".concat(duration, " min")
                                }),
                                watched && /*#__PURE__*/ _jsx(Badge, {
                                    className: cn(styles.watchedBadge, {
                                        [styles.isPortrait]: isPortrait
                                    }),
                                    rounded: true,
                                    outlined: true,
                                    skin: "success",
                                    size: isPortrait ? 'big' : 'default',
                                    testId: "tutorial-video-watched-tag",
                                    children: "Watched"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
